module.exports = __webpack_public_path__ + "static/img/first-invite-red.07bef41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/first-invite-red.png
// module id = 8dti
// module chunks = 215